enum asclepiusApiEvents {
  ACCESS_TOKEN_REFRESHED = "ACCESS_TOKEN_REFRESHED",
  UNAUTHENTICATED_API_ERROR_RESPONSE_RECEIVED = "UNAUTHENTICATED_API_ERROR_RESPONSE_RECEIVED"
}

export default asclepiusApiEvents
